export function humanizeFilename(filename) {
  const baseName = filename.replace(/\.[^/.]+$/, "");
  const processedName = baseName.replace(/[^0-9a-zA-Z]+/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

  return processedName;
}
